import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Trash2, X, Loader2 } from 'lucide-react';

/**
 * Lišta hromadných akcí — zobrazí se, když je něco vybráno.
 * Props:
 *  - count: počet vybraných
 *  - onDelete: async () => {}  (provede smazání výběru)
 *  - onClear: () => {}         (zruší výběr)
 *  - entityLabel: text pro potvrzení, např. "společností"
 */
export default function BulkDeleteBar({ count, onDelete, onClear, entityLabel = 'položek' }) {
  const [busy, setBusy] = useState(false);
  if (!count) return null;

  const handleDelete = async () => {
    if (!window.confirm(`Opravdu smazat ${count} ${entityLabel}? Tuto akci nelze vrátit.`)) return;
    setBusy(true);
    try {
      await onDelete();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="bulk-actions-bar"
      className="flex items-center justify-between gap-3 px-3 py-2 rounded-md mb-2"
      style={{ background: 'var(--ct-bg-secondary)', border: '1px solid var(--ct-border)', boxShadow: 'var(--ct-shadow-sm)' }}
    >
      <span className="text-sm font-medium">Vybráno: {count}</span>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onClear} disabled={busy} className="gap-1 text-xs">
          <X className="w-3.5 h-3.5" /> Zrušit výběr
        </Button>
        <Button
          size="sm"
          onClick={handleDelete}
          disabled={busy}
          className="gap-1 text-xs"
          style={{ background: 'var(--ct-error)', color: '#fff' }}
        >
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Trash2 className="w-3.5 h-3.5" />}
          Smazat vybrané
        </Button>
      </div>
    </div>
  );
}
